/* ============================================================
   FitLibrary — fitlibrary-product.js
   Real Shopify purchase behaviour for every product template:
   Ajax add-to-cart with loading / success / error / sold-out
   states, accessible status announcements, duplicate-submit
   protection, dynamic cart count. Also editorial page-preview
   hover and the desktop/mobile loop orientation.

   2026-08-05 · CART REDIRECT AFTER A SUCCESSFUL ADD — opt-in.
   A form redirects to the cart only if it opts in, so no other
   product form in the theme inherits the behaviour. Two ways in:

     1. `data-fl-redirect-cart` on the form — the declarative way,
        available to anything added later.
     2. The form sits inside one of the five product-hero section
        wrappers listed in HERO_SECTIONS. Those five classes cover
        exactly the eight individual product heroes (the four eBook
        heroes share `.nn-hero-section`; each Practical Pack hero
        has its own) and are used nowhere else in the theme, so the
        match is precise without editing eight large section files.

   The redirect runs ONLY after a successful /cart/add.js response.
   An error keeps the customer on the page with the existing
   accessible message. The destination is the locale-aware cart:
   `data-fl-cart-url` when the section provides `routes.cart_url`,
   otherwise Shopify's locale-aware root + "cart".
   ============================================================ */
(function () {
  "use strict";
  var FL = (window.FitLibrary = window.FitLibrary || {});
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* The eight individual product heroes — and nothing else. */
  var HERO_SECTIONS =
    ".nn-hero-section, .np-hero-section, .tp-hero-section, .rp-hero-section, .hp-hero-section";

  function wantsCartRedirect(form) {
    if (form.hasAttribute("data-fl-redirect-cart")) return true;
    return !!(form.closest && form.closest(HERO_SECTIONS));
  }

  function cartUrl(form) {
    return form.getAttribute("data-fl-cart-url") || (ROOT + "cart");
  }

  function setState(form, state, message) {
    var btn = form.querySelector("[data-fl-submit]");
    var status = form.querySelector("[data-fl-form-status]");
    if (btn) {
      btn.classList.toggle("is-loading", state === "loading");
      btn.classList.toggle("is-success", state === "success");
      btn.disabled = state === "loading" || state === "soldout";
      btn.setAttribute("aria-busy", state === "loading" ? "true" : "false");
    }
    if (status) {
      status.textContent = message || "";
      status.hidden = !message;
    }
    if (message) FL.announce(message);
  }

  FL.register("ProductForm", function (scope) {
    (scope || document).querySelectorAll("[data-fl-product-form]").forEach(function (form) {
      if (form.dataset.flBound === "true") return;
      form.dataset.flBound = "true";

      form.addEventListener("submit", function (e) {
        var btn = form.querySelector("[data-fl-submit]");
        if (btn && btn.disabled) { e.preventDefault(); return; }
        if (!window.fetch) return; /* progressive enhancement: native POST */
        e.preventDefault();
        setState(form, "loading", "Adding to your cart…");

        fetch(ROOT + "cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) {
              setState(form, "error", res.body.description || "This item could not be added.");
              return;
            }
            setState(form, "success", "Added to your cart.");

            /* Only after a confirmed add, and only for opted-in forms. The
               button stays disabled through the navigation, so a second
               submit is impossible while the page unloads. */
            if (wantsCartRedirect(form)) {
              window.location.assign(cartUrl(form));
              return;
            }

            return FL.refreshCartCount().then(function () {
              document.dispatchEvent(new CustomEvent("fitlibrary:cart:updated"));
              window.setTimeout(function () { setState(form, "idle", ""); }, 2400);
            });
          })
          .catch(function () {
            setState(form, "error", "Something went wrong. Please try again.");
          });
      });
    });
  });

  /* Editorial page previews — hover lift only when motion is allowed. */
  FL.register("PagePreview", function (scope) {
    if (FL.reduceMotion()) return;
    (scope || document).querySelectorAll("[data-fl-page-preview]").forEach(function (el) {
      if (el.dataset.flBound === "true") return;
      el.dataset.flBound = "true";
      el.addEventListener("mouseenter", function () { el.classList.add("is-hover"); });
      el.addEventListener("mouseleave", function () { el.classList.remove("is-hover"); });
      el.addEventListener("focusin", function () { el.classList.add("is-hover"); });
      el.addEventListener("focusout", function () { el.classList.remove("is-hover"); });
    });
  });

  /* Horizontal desktop loop / vertical mobile loop — orientation only. */
  FL.register("Loop", function (scope) {
    (scope || document).querySelectorAll("[data-fl-loop]").forEach(function (loop) {
      if (loop.dataset.flBound === "true") return;
      loop.dataset.flBound = "true";
      var mq = window.matchMedia("(min-width: 861px)");
      function apply() { loop.setAttribute("data-orientation", mq.matches ? "horizontal" : "vertical"); }
      apply();
      if (mq.addEventListener) mq.addEventListener("change", apply);
      else if (mq.addListener) mq.addListener(apply);
    });
  });
})();